<template>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">  
          <div class="form-group">  
            <h4>{{ _('Product') }}</h4>
            <div class="form-group">
              <select class="form-control" id="productSelector" :placeholder="_('Loading products, please wait...')" v-model="product">
                <option v-if="!products.length">{{ _('Loading products, please wait...') }}</option>
                <option v-else :value="null">{{ _('Select product') }}</option>
                <option v-for="product in products" :value="product">{{ product.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <div class="checkbox">
                <label>
                  <input type="checkbox" v-model="copyOrReplace" />
                  {{ _('Replace current price rows') }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
      <button type="button" class="btn btn-success" v-on:click="selectProduct" :disabled="!product"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['baseDomain', 'shopId', 'apiKey'],
  data () {
    return {
      copyOrReplace: false,
      product: null,
      products: []
    }
  },
  methods: {
    async loadProducts () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/products.json?iSortingCols=1&iSortCol_0=2&sSortDir_0=asc&sSearch_3=1&simple=true&apikey=' + this.apiKey)
      } catch (e) {
        return
      }
      this.products = response.data
    },
    close () {
      this.$emit('close')
    },
    selectProduct () {
      this.$emit('selectProduct', { product: this.product, copyOrReplace: this.copyOrReplace })
    }
  },
  mounted () {
    this.loadProducts()
  }
}
</script>